import React, {Children, useEffect, useRef} from 'react';
import {register} from 'swiper/element/bundle';
import useId from "@mui/material/utils/useId";
import './style.css';

register();

const ISwiper = ({
                     slidePerView = 3,
                     navigation = false,
                     pagination = false,
                     onSlideChange = null,
                     onSlideProgress = null,
                     children
                 }) => {
    const swiperElRef = useRef(null);
    const arrayChildren = Children.toArray(children);
    const id = useId();

    useEffect(() => {
        // listen for Swiper events using addEventListener
        swiperElRef.current?.addEventListener('progress', (e) => {
            const [swiper, progress] = e.detail;
            if (onSlideProgress) onSlideProgress();
        });

        swiperElRef.current?.addEventListener('slidechange', (e) => {
            if (onSlideChange) onSlideChange();
        });
    }, []);

    return (
        <swiper-container
            ref={swiperElRef}
            slides-per-view={`${slidePerView}`}
            navigation={`${navigation}`}
            pagination={`${pagination}`}
            autoplay={true}
            autoplay-delay={1}
            speed={5000}
            loop={true}
            loop-prevents-slide={false}
        >
            {arrayChildren?.map((child, index) => {
                return (
                    <swiper-slide id={`slide_${index}`} key={`slide_${id}_${index}`} >
                        {child}
                    </swiper-slide>
                )
            })}

        </swiper-container>
    )
};

export default ISwiper;

